import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserHasAccess, PermissionName} from './currentUserHasAccess';
import {legacyPermissionsEnabled} from './legacyPermissionsEnabled';

export const permissionsAllowDownload = () => {
	if (legacyPermissionsEnabled())
		return currentUserMeetsUserLevel(UserLevel.CONSUMER);
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};
